import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ComentarioRequest } from '../../requests/compras/comentario.request';
import { AdicionarComentarioResponse } from '../../responses/compras/compra-comentario.response';

@Injectable({
  providedIn: 'root',
})
export class CompraComentarioService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraComentario';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public adicionarComentario(idCompra: number, texto: string, idsUsuarioMencionado: number[]): Observable<AdicionarComentarioResponse> {
    const request: ComentarioRequest = { texto, idsUsuarioMencionado };
    return this.httpClient
      .post<AdicionarComentarioResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
